// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";

function TbUnitPreview(Props) {
  var unitId = Props.unitId;
  var match = Jotai.useAtom(TbAtoms.useSkins);
  return React.createElement(UnitImage.make, {
              skin: unitId === "TFT12_Yuumi" ? false : match[0],
              unitId: unitId,
              size: unitId === "TFT12_Yuumi" ? 32 : 44,
              sizeSm: unitId === "TFT12_Yuumi" ? 32 : 48,
              sizeMd: unitId === "TFT12_Yuumi" ? 32 : 52,
              showName: false
            });
}

var make = React.memo(TbUnitPreview);

export {
  make ,
  
}
/* make Not a pure module */
